import React, { Component } from 'react';
import {Form, FormControl, Button, Row, Col} from 'react-bootstrap';
import { sendJson } from '../../backend/Backend';
import { LIGHT_BG } from '../../backend/Colors';
import { translate } from "react-i18next";



function emptyComment() {
    return {
      comment:'',
      username:'',
      eventId:'',
      userId:'',
      email:'',
      id:0,
      parentId:null,
      sortId:null,
      parentName:'',
      creationDate: new Date()
    };
  }

  
class CommentAdd extends Component {

    constructor(props) {
        super(props);

        this.onCommentAdd = this.onCommentAdd.bind(this);
        this.onCommentInputChange = this.onCommentInputChange.bind(this);

        this.state = {
            comment: emptyComment()
        };
    }

    onCommentAdd() {
        let oldComment = this.state.comment;

        oldComment.eventId = this.props.invitedUser.eventId;
        oldComment.email = this.props.invitedUser.email;
        oldComment.userId = this.props.invitedUser.id;
        oldComment.username = this.props.invitedUser.name;
        if(this.props.parentId){
            oldComment.parentId = this.props.parentId;
            oldComment.sortId = this.props.parentId;
            oldComment.parentName = this.props.invitedUser.name;
        }
        sendJson('post', 'userComments', this.state.comment).then(
            received => {
              this.props.onAdd(received); 
              this.setState({
                comment: emptyComment()
                });
            });
    }

    onCommentInputChange(event) {
        const { name: fieldName, value: fieldValue } = event.target;
        const { comment } = this.state;

        const newComment = {
        ...comment,
        [fieldName]: fieldValue
        };

        this.setState({
        comment: newComment
        });
  }


    render() {
        const { t } = this.props;
        return (
         <Row >
             <Col lg={8} className=" pt-2 pb-2  mb-1" style={{"backgroundColor": LIGHT_BG}}>
             <Form>
                    <FormControl
                        as="textarea"
                        placeholder={t(this.props.parentId ?"AntwortEingeben": "KommentarEingeben",{"u":this.props.invited} )}
                        onChange={this.onCommentInputChange}
                        name="comment"
                        value={ this.state.comment.comment}
                    />
                    <Button variant="outline-dark" onClick={this.onCommentAdd} className="mt-3 float-right">{t("send")}</Button>
                    </Form>
             </Col>
         </Row>
               
           
        )
    }
}

export default translate("translations")(CommentAdd);